<div *ngIf="(loading$|async)" class="d-flex justify-content-center align-items-center h-100 w-100">
  <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
</div>
<ng-scrollbar visibility="hover" class="w-100 vh-100 position-relative d-flex flex-column"
                   *ngIf="!(loading$ |async) && (companyPage$| async) as companyPage"
                   [config]="{suppressScrollX: showEditField, suppressScrollY:showEditField}">


  <div class="member-page d-flex flex-column">
    <div class="title-picture-container position-relative">
      <img alt="background" class="title-picture" [src]="titlePicture?? 'assets/img/profile/default-banner.jpg'"/>

      <ng-container *ngIf="isPageAdmin">
        <label for="title-picture-upload" class="edit-container edit-title-picture">
          <mat-icon>edit</mat-icon>
        </label>
        <input id="title-picture-upload" type="file" accept="image/png, image/jpeg"
               (change)="onFileChange($event, 'titlePicture')"
               class="d-none">
      </ng-container>
    </div>
    <div class="under-title-picture">
      <div class="profile-picture-container">
        <img alt="logo" class="profile-picture" [src]="logo ?? 'assets/img/profile/default-business-logo.png'"/>
        <ng-container *ngIf="isPageAdmin">


          <span (click)="editImage= true" class="edit-container edit-profile-picture">
            <img src="assets/svg-icons/camera.svg" alt="camera icon">
          </span>
        </ng-container>
      </div>

      <div class="information-card ">
        <span class="name">
          {{companyPage.name}}
        </span>
        <span>&nbsp;</span>
        <hr>
        <span *ngIf="companyPage.seatNumber">
          {{'memberPage.seat' | translate}} {{companyPage.seatNumber}}
        </span>
      </div>
    </div>
    <div class=" buttons-container d-flex flex-row">


      <button *ngIf="isPageAdmin" class="blue-border flex-center more-button"
              [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
        {{'memberPage.more' | translate}}
      </button>
      <mat-menu #menu="matMenu" class="profile-user-panel">
        <button class="flex-center mat-menu-button" mat-menu-item *ngIf="isPageAdmin"
                (click)="showEditField=true">
          <mat-icon>edit icon</mat-icon>
          <span class="text">{{'memberPage.edit' | translate}}</span>
        </button>
      </mat-menu>

    </div>
    <hr class="mx-0 top-separator">
    <div class="content">
      <div *ngIf="companyPage.offeringLOBs.length>0 || companyPage.lookingForLOBs.length>0 || companyPage.offeringExpertServices.length>0"
           class="specialities-container d-flex flex-row">
        <div class="specialities-container-offering" *ngIf="companyPage.offeringExpertServices.length>0">
          <span class="headline">
            {{'companyPage.expertise' | translate}}
            <span class="badge">
              {{companyPage.offeringExpertServices.length}}
            </span>
          </span>
          <div class="chip-list">
            <div class="chip" *ngFor="let serv of companyPage.offeringExpertServices | slice:0:maxLobShown">
              {{'expertServices.clauses.' + serv.number + '.name' | translate}}
            </div>
          </div>
          <button *ngIf="companyPage.offeringExpertServices.length >3"
                  (click)="toggleMaxLobShow()"
                  class="blue-border w-fit-content">{{(maxLobShown == 3 ? 'memberPage.showMore' : 'memberPage.showLess') | translate}}</button>
        </div>
        <div class="specialities-container-offering" *ngIf="companyPage.offeringLOBs.length>0">
          <span class="headline">
            {{'companyPage.lobsoffering' | translate}}
            <span class="badge">
              {{companyPage.offeringLOBs.length}}
            </span>
          </span>
          <div class="chip-list">
            <div class="chip" *ngFor="let lob of companyPage.offeringLOBs | slice:0:maxLobShown">
              {{'lineOfBusiness.clauses.' + lob.number + '.name' | translate}}
            </div>
          </div>
          <button *ngIf="companyPage.offeringLOBs.length >3"
                  (click)="toggleMaxLobShow()"
                  class="blue-border w-fit-content">{{(maxLobShown == 3 ? 'memberPage.showMore' : 'memberPage.showLess') | translate}}</button>
        </div>
        <div class="specialities-container-interested">
          <span class="headline" *ngIf="companyPage.lookingForLOBs.length>0">
            {{'companyPage.lobsinterested' | translate}}
            <span class="badge">
              {{companyPage.lookingForLOBs.length}}
            </span>
          </span>
          <div class="chip-list">
            <div class="chip" *ngFor="let lob of companyPage.lookingForLOBs | slice:0:maxLobShown">
              {{'lineOfBusiness.clauses.' + lob.number + '.name' | translate}}
            </div>
          </div>
          <button *ngIf="companyPage.lookingForLOBs.length > 3 "
                  (click)="toggleMaxLobShow()"
                  class="blue-border w-fit-content">{{(maxLobShown == 3 ? 'memberPage.showMore' : 'memberPage.showLess') | translate}}</button>
        </div>
      </div>
      <div class="information-container d-flex flex-column"
           *ngIf="companyPage.description != null && companyPage.description.trim() !== ''">
        <span class="title"> {{'companyPage.description' | translate}}</span>
        <span #introductionText class="introduction-text"
              [class.show-all]="showCompleteIntroductionText">{{companyPage.description}}</span>
        <button class="blue-border w-fit-content"
                *ngIf="showCompleteIntroductionText || (introductionText?.scrollHeight > introductionText?.clientHeight)"
                (click)="toggleCompleteIntroductionText()">{{(showCompleteIntroductionText ? 'memberPage.showLess' : 'memberPage.showMore') | translate}}</button>
      </div>


      <div class="content-container" >
        <ng-container *ngIf="companyPage.users && companyPage.users.length > 0 && hasCorporateAdminRole(companyPage.users)
        && (belongsToCompany(companyPage.users, activeUser$|async) || hasAdminRole(activeUser$|async))">
          <span class="title"> {{'companyPage.corporateAdminTitle' | translate}}</span>
          <div class="d-flex flex-wrap contact-person-outer-container">
            <ng-container *ngFor="let user of companyPage.users">
              <ng-container *ngIf="user.isCorporateAdmin">
                <ng-container *ngTemplateOutlet="contactPerson; context:{user}"></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="companyPage.users && companyPage.users.length > 0 && hasExchangeRole(companyPage.users)">
          <span class="title"> {{'companyPage.contactPersons' | translate}}</span>
          <div class="d-flex flex-wrap contact-person-outer-container">
            <ng-container *ngFor="let user of companyPage.users">
              <ng-container *ngIf="user.type === Roles.ROLE_BROKER || user.type === Roles.ROLE_INSURER || user.type === Roles.ROLE_UNDERWRITER || user.type === Roles.ROLE_EXPERT">
                <ng-container *ngTemplateOutlet="contactPerson; context:{user}"></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="companyPage.users && companyPage.users.length > 0 && hasRepresentativeRole(companyPage.users)">
          <span class="title"> {{'companyPage.contactPersonsinHVB' | translate}}</span>
          <div class="d-flex flex-wrap contact-person-outer-container">
            <ng-container *ngFor="let user of companyPage.users">
              <ng-container *ngIf="user.isRepresentative">
                <ng-container *ngTemplateOutlet="contactPerson; context:{user}"></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

      </div>

      <div class="contact-container d-flex flex-column">
        <span class="title"> {{'companyPage.contact' | translate}}</span>
        <div class="d-flex flex-row justify-content-between contact-content">
          <div class="d-flex flex-column contact-information">
            <div class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/mail.svg" alt="">
              <a href="mailto:{{companyPage.emailAddress}}">
                {{companyPage.emailAddress}}
              </a>
            </div>
            <div *ngIf="companyPage.telephoneNumber" class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/call.svg" alt="">
              <span>
                {{companyPage.telephoneNumber}}
              </span>
            </div>
            <div *ngIf="companyPage.faxNumber" class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/inbox.svg" alt="">
              <span>
                {{companyPage.faxNumber}}
              </span>
            </div>
            <div class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/building-business-office.svg" alt="">
              <span>{{companyPage.name}}</span>
            </div>
            <div class="contact-text d-flex align-items-center">
              <img class="contact-icon" src="assets/svg-icons/profile-user/location.svg" alt="">
              <span>
            {{companyPage.street}} {{companyPage.houseNumber}},
                {{companyPage.postalCode}} {{companyPage.location}}
          </span>
            </div>
          </div>
          <iframe
            *ngIf="companyPage.street != null && companyPage.houseNumber != null && companyPage.postalCode != null && companyPage.location != null"
            class="flex-grow-1 google-maps"
            title="google-maps"
            style="border:0"
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            [src]="('https://www.google.com/maps/embed/v1/place?key='+ environment.mapsApiKey+ '&q=' + companyPage.street + '+' + companyPage.houseNumber + ',' + companyPage.postalCode + '+' +companyPage.location ) | safe">
          </iframe>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showEditField" class="position-absolute edit-page">

    <ng-scrollbar visibility="hover" class="h-100 ">

      <div class="edit-field d-flex flex-row">
        <app-company-profile-edit (close)="showEditField = false" (updated)="reloadInformation()" class="flex-grow-1"
        ></app-company-profile-edit>
      </div>
    </ng-scrollbar>
  </div>

</ng-scrollbar>
<ng-template #contactPerson let-user="user">

  <div class="contact-person-container">
    <img class="profile-picture"
         [src]="(userService.getProfilePicture(user.id) |async) ?? 'assets/img/profile/default-profile-icon.png'"
         alt=""/>
    <span class="name">{{user.firstName}} {{user.lastName}}</span>
    <ng-container *ngIf="companyRole === Roles.ROLE_BROKER || companyRole === Roles.ROLE_INSURER || companyRole === Roles.ROLE_UNDERWRITER">
      <div class="type" [class.visibility-hidden]="!companyRole">
        <span>{{'companyRole.' + companyRole | translate}}</span>
      </div>
    </ng-container>
    <span class="seat-number"
           [class.visibility-hidden]="!user.company.seatNumber">{{user.company.seatNumber ? user.company.seatNumber : 'none'}}</span>
    <button class="blue-border"
            (click)="navigateToUserProfile(user.id)">{{'companyPage.toProfile'|translate}}
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

  <div *ngIf="editImage" class="position-fixed edit-image-container">
    <div class="edit-image">
      <div class="d-flex justify-content-between w-100">
        <span class="title">{{'memberPage.editImage.title'|translate}}</span>
        <mat-icon class="cursor-pointer" (click)="editImage = false">close</mat-icon>
      </div>
      <img alt="profile" class="profile-picture"
           [src]="logo ?? 'assets/img/profile/default-business-logo.png'"/>
      <div class="buttons">
        <label for="profile-logo-upload">
          <img src="assets/svg-icons/camera.svg" alt="">
          <label for="profile-logo-upload">{{'memberPage.editImage.add'|translate}}</label>

        </label>
        <input id="profile-logo-upload" type="file" accept="image/png, image/jpeg"
               (change)="onFileChange($event, 'logo')"
               class="d-none">
        <div (click)="deleteLogo()">
          <img src="assets/svg-icons/delete.svg" alt="">
          <span>{{'memberPage.editImage.delete'|translate}}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
